import Challenges from './Challenges';
import { useStatusBarColour } from '../../Components/Mobile';

const Login = () => {
    useStatusBarColour('#F8F9FA');

    return <Challenges />;
}

export default Login;
